<template>
  <div style="width: 100%">
    <div class="flex app-content-back mt-0 align-top min-h-screen">
      <div class="mt-2 lg:mt-8 flex flex-col lg:flex-row w-full">
        <div class="main-button-col lg:mr-32 ">
          <div class="flex flex-row lg:flex-col">
            <router-link :to="{ name: 'today' }">
              <pv-button class="main-button">
                <div class="flex flex-row">
                  <div class="flex text text-4xl main-button-icon">
                    <i class="fas fa-running mr-4" />
                  </div>
                  <div class="text-3xl">
                    <p class="mb-0 uppercase leading-loose tracking-wider">
                      Heute
                    </p>
                    <p class="-mt-4 text-sm font-thin">
                      Übersicht über die heutigen Trainingseinheiten
                    </p>
                  </div>
                </div>
              </pv-button>
            </router-link>

            <router-link :to="{ name: 'exercises' }">
              <pv-button class="main-button">
                <div class="flex flex-row">
                  <div class="flex text text-4xl main-button-icon">
                    <i class="fas fa-running mr-4" />
                  </div>
                  <div class="text-3xl">
                    <p class="mb-0 uppercase leading-loose tracking-wider">
                      Übungen
                    </p>
                    <p class="-mt-4 text-sm font-thin">
                      Einsehen der Übungssammlung und erstellen einer Trainingseinheit
                    </p>
                  </div>
                </div>
              </pv-button>
            </router-link>
            <router-link :to="{name:'masteries'}">
              <pv-button class="main-button">
                <div class="flex flex-row ">
                  <div class="flex text text-4xl main-button-icon">
                    <i class="fas fa-chart-line mr-4" />
                  </div>
                  <div class="text-3xl">
                    <p class="mb-0 uppercase leading-loose tracking-wider">
                      Masteries
                    </p>
                    <p class="-mt-4 text-sm font-thin">
                      Beherrschen des Balls
                    </p>
                  </div>
                </div>
              </pv-button>
            </router-link>
              <pv-button class="main-button disabled">
                <div class="flex flex-row ">
                  <div class="flex text text-4xl main-button-icon">
                    <i class="fas fa-calendar mr-4" />
                  </div>
                  <div class="text-3xl">
                    <p class="mb-0 uppercase leading-loose tracking-wider">
                      Spieltage
                    </p>
                    <p class="-mt-4 text-sm font-thin">
                      Wer spielt wann?
                    </p>
                  </div>
                </div>
              </pv-button>
          </div>
        </div>

        <div class="mt-8 lg:mt-1 w-full flex flex-col">
          <WidgetSlotContainer
            v-if="teams"
            title="Meine Teams"
            :link="{ name: 'teams.manage' }"
            icon="fas fa-users"
            link-icon="fa fa-plus"
          >
            <div
              v-for="team in teams"
              :key="team.teamId"
              class="border-gray-dark border-b-2 pl-2 pb-2 pr-2"
            >
              <div class="flex flex-row">
                <router-link
                  :to="{name: 'teams.detail', params: { id: team.teamId} }"
                  class="mt-4 flex flex-row"
                >
                  <div class="w-16">
                    {{ team.key }}
                  </div>
                  - {{ team.name }}
                </router-link>
              </div>
              <div class="text-sm font-light mb-1 flex flex-row ">
                Letztes Training:
                <div
                  v-if="team.nextSession"
                  class="ml-4"
                >
                  <router-link :to="{name:'training.sessions.modify',params :{id:team.nextSession.id}}">
                    <i class="far fa-calendar-check mr-1" /><span>{{ team.nextSession.date | formatDate }}</span>
                    {{ team.nextSession.title }}
                  </router-link>

                  <router-link
                    :to="{name:'training.sessions.presence',params:{id:team.nextSession.id}}"
                    class="ml-3"
                  >
                    <span><i class="far fa-list-alt mr-1" />Anwesenheit </span>
                  </router-link>
                </div>
              </div>
            </div>
          </WidgetSlotContainer>

          <sc-sessions-next />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authService from '../auth/authService'
import apiService from './api/apiService'
import WidgetSlotContainer from '@/components/WidgetSlotContainer'
import { cookieConsent } from '@/components/cookies/cookieConsent'
import { userClient } from '@/components/api/clients.context'

export default {
    name: 'Home',
    components: { WidgetSlotContainer },
    data () {
        return {
            aviableTags: [],
            user: authService.user,
            loggedin: authService.user.loggedIn,
            teams: null,
            testImg: null,
            modal: true,
            visible: true
        }
    },
    async mounted () {
        const response = await apiService.getMyTeams()
        this.teams = response.data

        const test = await apiService.getImage('j2htb1jO5PUMBoMRcP9Lqa6cS')
        this.testImg = test

      this.me = await userClient.getMe()

      if (this.$route.name !== 'me' && (!this.me || !this.me.displayName)) {
        await this.$router.push({ name: 'me' })
      }
    },
    methods: {
        getStatus () {
            apiService.getStatus().then(data => {
                console.log(data)
            })
        },
        login () {
            localStorage.setItem('loginRedirect', this.$route.fullPath)
            authService.login()
        }
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-button {
  margin-bottom: 2rem;
  width: 19rem;
  align-items: start;
  height: 8rem;
  margin: 12px;
}

.main-button-icon {
  margin-top: 2rem;
}

.main-button-col {
  width: 22rem;

}

.dialog {

}

.action {

}
</style>
